{
  "Parametre": "Parameter",
  "parametre": {
    "E-Mail Görünen mail adres": "E-Mail (Display Address)",
    "Firma Adı": "Company Name",
    "Host": "Host",
    "Mail": "Email",
    "Mail Test": "Mail Test",
    "Parametre": "Parameter",
    "Port": "Port",
    "Varsayılan Şifre": "Default Password",
    "Yemek Bedeli": "Food Cost",
    "Kapalı": "Disabled",
    "E-Posta": "E-Mail",
    "SMS": "SMS",
    "Kullanıcı Tercih Edecek": "User Preference",
    "Two Factor Type": "Two Factor Support Type",
    "Seçiniz": "Select",
    "Yeni Kullanıcı Kaydı Aktif": "New User Registration Active",
    "Şifremi Unuttum Aktif": "Forgot Password Active",
    "Gizlilik Sözleşmesi Metni": "Privacy Policy Text",
    "Kurumsal Bilgiler": "Corporate Information",
    "Firma Kısa Ad": "Company Short Name",
    "Kuruluş Yılı": "Establishment Year",
    "Telefon 1": "Phone 1",
    "Telefon 2": "Phone 2",
    "Telefon 3": "Phone 3",
    "E-mail 1": "E-mail 1",
    "E-mail 2": "E-mail 2",
    "E-mail 3": "E-mail 3",
    "Adres": "Address",
    "Adres Koordinat X": "Address Coordinate X",
    "Adres Koordinat Y": "Address Coordinate Y",
    "İletişim Form Mail": "Contact Form E-mail",
    "SEO Bilgileri": "SEO Information",
    "Site Açıklaması": "Site Description",
    "Anahtar Kelimeler": "Keywords",
    "Diğer Ayarlar": "Other Settings",
    "Facebook": "Facebook",
    "Twitter (X)": "Twitter (X)",
    "Instagram": "Instagram",
    "Youtube": "Youtube",
    "Pinterest": "Pinterest",
    "Aktif": "Active",
    "satis_izin_gun": "Sales Permission Days",
    "komisyon_vergi": "Commission Tax Rate",
    "ape_tarih_ay": "APE Date Month",
    "ape_taksit": "APE Installment Count",
    "ape_peryot": "APE Period Month Count",
    "smape_tip": "SM APE Calculation Type (0:Sales, 1:Commission)",
    "smape_tarih_ay": "SM APE Date Month",
    "smape_taksit": "SM APE Installment Count",
    "smape_peryot": "SM APE Period Month Count",
    "mesai_0": "Sunday",
    "mesai_1": "Monday",
    "mesai_2": "Tuesday",
    "mesai_3": "Wednesday",
    "mesai_4": "Thursday",
    "mesai_5": "Friday",
    "mesai_6": "Saturday",
    "panel_ayarlari": "Panel Settings",
    "mesai_saatleri": "Working Hours",
    "mail_encryption": "Mail Encryption (TLS/SSL)",
    "SMS Servis Sağlayıcı": "SMS Service Provider",
    "SMS Başlığı": "SMS Header",
    "Servis Kullanıcı Adı / API Key": "Service Username / API Key",
    "Servis Şifresi / API Secret": "Service Password / API Secret",
    "Parametre Ayarları": "Parameter Settings",
    "Genel Bilgi": "General Info",
    "Sosyal Medya": "Social Media",
    "Mail Ayarları": "Mail Settings",
    "2FA Ayarları": "2FA Settings",
    "Panel Ayarları": "Panel Settings",
    "SMS Ayarları": "SMS Settings",
    "Programcı": "Programmer",
    "E-posta 1": "E-mail 1",
    "E-posta 2": "E-mail 2",
    "E-posta 3": "E-mail 3",
    "Mesai Saatleri": "Working Hours",
    "OrnFirmaAdi": "e.g. COMPANYNAME"
  }
}
